import React from "react";

interface StepperProps {
  prevStepLabel?: string;
  currentStepLabel: string;
  nextStepLabel?: string;
  onPrev?: () => void;
  hideNextStep?: boolean;
}

const Stepper: React.FC<StepperProps> = ({ prevStepLabel, currentStepLabel, nextStepLabel, hideNextStep }) => {
  return (
    <div className="w-full flex items-center justify-center gap-6 mb-3 select-none">
      {/* Previous Step (Display-only) */}
      <div className="flex-1 flex justify-end">
        {prevStepLabel ? (
          <div className="flex items-center gap-2 text-[#9CA3AF] font-plus-jakarta text-[14px] font-medium">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            <span className="truncate max-w-[120px] sm:max-w-[150px]">{prevStepLabel}</span>
          </div>
        ) : (
          <div className="w-[150px]" />
        )}
      </div>

      {/* Current Step */}
      <div className="flex-shrink-0 px-6 py-2 bg-[#F9FAFB] border border-[#D7DFEC] rounded-full flex items-center justify-center shadow-sm">
        <span className="font-plus-jakarta text-[#141435] font-bold text-[15px]">
          {currentStepLabel}
        </span>
      </div>

      {/* Next Step */}
      <div className="flex-1 flex justify-start">
        {nextStepLabel && !hideNextStep ? (
          <div className="flex items-center gap-2 text-[#9CA3AF] font-plus-jakarta text-[14px] font-medium">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
            <span className="truncate max-w-[120px] sm:max-w-[150px]">{nextStepLabel}</span>
          </div>
        ) : (
          <div className="w-[150px]" />
        )}
      </div>
    </div>
  );
};

export default Stepper; 